// The colour theme: `auto` follows the system's light or dark as it
// changes, `light` and `dark` hold one whatever the system says. Applying a
// theme only marks the root element (`data-theme`, absent for `auto`); the
// stylesheet (styles/tokens.css) does the rest, its tokens and the native
// `color-scheme` following that mark, or the system's preference without
// one. The web app and the browser extension apply it alike, each keeping
// its own choice.

export type Theme = 'auto' | 'light' | 'dark';

/** The themes in the order the theme button steps through them. */
export const THEMES: readonly Theme[] = ['auto', 'light', 'dark'];

/** Each theme's name where the choices are listed (a settings row). */
export const THEME_LABELS: Readonly<Record<Theme, string>> = { auto: 'Match the system', light: 'Light', dark: 'Dark' };

export const isTheme = (v: unknown): v is Theme => typeof v === 'string' && (THEMES as readonly string[]).includes(v);

/** The theme after `theme`, around the end: the theme button's step. */
export const nextTheme = (theme: Theme): Theme => THEMES[(THEMES.indexOf(theme) + 1) % THEMES.length];

/** The theme button's accessible name and tooltip: the theme it is on. */
export const themeTitle = (theme: Theme) => `Color theme: ${theme}`;

/** Marks `root` (the document's root element) for `theme`. */
export function applyTheme(theme: Theme, root: { dataset: DOMStringMap } = document.documentElement) {
  if (theme === 'auto') delete root.dataset.theme;
  else root.dataset.theme = theme;
}
